// Variante "Striche": das Flugzeug entsteht aus den sechs Balken links und
// rechts des Schriftzugs - nicht aus dem A.
//
//   die beiden oberen Balken  -> das Leitwerk
//   die beiden mittleren      -> die Fluegel (liegen schon richtig, klappen nur ein)
//   die beiden unteren        -> die zwei Rumpfhaelften (Balken stellt sich auf)
//
// Das A schrumpft dabei in die Mitte weg. Jeder Balken ist ein Viereck; sein
// Umriss wird auf die Eckenzahl des Zielteils nachgeteilt, dadurch bleibt jede
// Kante waehrend der ganzen Faltung eine Gerade. Bei t = 0 stehen alle sechs
// Balken exakt im Original, bei t = 1 ergeben sie exakt PLANE_D.

export const VIEW_BOX = '0 0 627.49 105.58';
export const ACCENT = '#E5C29D';

const TEXT_D = "M118.56,38.99h-14.3v-.67l3.12-.67V6.78l-3.12-.72v-.67h14.3c1.63,0,3.13.19,4.49.58,1.36.38,2.53.94,3.5,1.66.98.72,1.74,1.6,2.28,2.64.54,1.04.82,2.22.82,3.53,0,2.11-.65,3.84-1.94,5.18-1.3,1.34-3.03,2.27-5.21,2.78,2.59.45,4.67,1.4,6.24,2.86,1.57,1.46,2.35,3.32,2.35,5.59,0,1.38-.3,2.61-.91,3.7-.61,1.09-1.46,2.01-2.57,2.76-1.1.75-2.42,1.33-3.96,1.73-1.54.4-3.23.6-5.09.6ZM111.22,21.22h6.62c1.15,0,2.2-.16,3.14-.48.94-.32,1.77-.78,2.47-1.39.7-.61,1.25-1.37,1.63-2.28.38-.91.58-1.97.58-3.19s-.19-2.22-.58-3.12c-.38-.9-.93-1.66-1.63-2.28-.7-.62-1.53-1.1-2.47-1.42-.94-.32-1.99-.48-3.14-.48h-6.62v14.64ZM117.84,37.83c1.34,0,2.58-.17,3.7-.5,1.12-.34,2.09-.83,2.9-1.49.82-.66,1.46-1.46,1.92-2.42.46-.96.7-2.06.7-3.31s-.23-2.36-.7-3.34c-.46-.98-1.1-1.79-1.92-2.45-.82-.65-1.78-1.15-2.9-1.49-1.12-.34-2.35-.5-3.7-.5h-6.62v15.51h6.62ZM160.7,33.27h-1.05l-1.83,4.56h-15.65v-15.55h12.14l.91,3.46h.91v-8.11h-.91l-.91,3.46h-12.14V6.59h15.17l1.82,4.56h1.06l-.29-5.76h-24.72v.67l3.12.72v30.86l-3.12.67v.67h25.2l.29-5.71ZM173.53,38.99h-8.45v-.77l3.07-.86,13.92-31.97h1.54l13.54,31.97,3.12.86v.77h-10.08v-.77l3.02-.86-4.08-9.79h-15.46l-4.22,9.79,4.08.86v.77ZM174.2,26.41h14.4l-7.1-16.99-7.3,16.99ZM203,26.65c0,1.95.31,3.71.94,5.26.62,1.55,1.51,2.87,2.66,3.96,1.15,1.09,2.52,1.92,4.1,2.5,1.59.58,3.34.86,5.26.86s3.67-.29,5.26-.86c1.58-.58,2.94-1.41,4.08-2.5,1.14-1.09,2.02-2.41,2.66-3.96.64-1.55.96-3.3.96-5.26V6.87l3.12-.91v-.58h-7.39v.58l3.12.86v19.82c0,1.73-.26,3.27-.77,4.61-.51,1.34-1.24,2.48-2.18,3.41-.94.93-2.06,1.63-3.34,2.11-1.28.48-2.69.72-4.22.72s-2.94-.24-4.2-.72c-1.26-.48-2.36-1.18-3.29-2.11-.93-.93-1.65-2.07-2.16-3.41-.51-1.34-.77-2.88-.77-4.61V7.02l3.12-.86v-.77h-10.08v.77l3.12.86v19.63ZM239.34,6.59h9.41v30.67l-3.12.96v.77h10.08v-.77l-3.12-.86V6.59h9.31l1.82,4.56h1.06l-.29-5.76h-27.74l-.24,5.81h1.06l1.78-4.61ZM271.77,6.97l-3.02-.82v-.77h10.27v.77l-3.07.82,10.51,16.42,10.66-16.42-3.89-.82v-.77h8.45v.77l-3.17.82-11.52,17.71v12.67l3.02.86v.77h-9.98v-.77l3.12-.96v-12.58l-11.38-17.71ZM362.12,38.22l-3.02-.86V7.02l3.02-.86v-.77h-9.89v.77l3.12.86v30.24l-3.12.96v.77h9.89v-.77ZM378.87,38.99h-10.08v-.77l3.12-.96V6.78l-3.12-.72v-.67h13.82c1.66,0,3.18.21,4.56.62,1.38.41,2.56,1.01,3.55,1.77.99.77,1.76,1.71,2.3,2.83.54,1.12.82,2.4.82,3.84,0,1.25-.22,2.38-.65,3.41-.43,1.02-1.04,1.91-1.82,2.66-.78.75-1.72,1.36-2.81,1.83-1.09.46-2.3.77-3.65.94.7.32,1.33.86,1.87,1.61.54.75,1.09,1.56,1.63,2.43l5.9,10.13,2.98.77v.77h-6.14l-9.07-15.55h-6.34v13.92l3.12.86v.77ZM375.75,22.28h6.29c1.12,0,2.16-.17,3.12-.5.96-.34,1.78-.84,2.47-1.51.69-.67,1.22-1.5,1.61-2.47.38-.97.58-2.09.58-3.34s-.19-2.41-.58-3.38c-.39-.98-.92-1.8-1.61-2.47-.69-.67-1.51-1.18-2.47-1.51-.96-.34-2-.5-3.12-.5h-6.29v15.7ZM410.36,38.99h1.53l9.7-24,9.89,24h1.54l13.15-31.97,3.12-.86v-.77h-8.5v.77l4.08.86-11.28,27.94-11.42-27.94,3.17-.86v-.77h-10.18v.77l3.07.86,2.74,6.48-8.5,21.46-11.42-27.94,3.17-.86v-.77h-10.18v.77l3.12.86,13.2,31.97ZM442.47,37.35l13.92-31.97h1.54l13.54,31.97,3.12.86v.77h-10.08v-.77l3.02-.86-4.08-9.79h-15.46l-4.22,9.79,4.08.86v.77h-8.45v-.77l3.07-.86ZM448.52,26.41h14.4l-7.1-16.99-7.3,16.99ZM481.01,24.68v12.58l-3.12.96v.77h9.98v-.77l-3.02-.86v-12.67l11.52-17.71,3.17-.82v-.77h-8.45v.77l3.89.82-10.66,16.42-10.51-16.42,3.07-.82v-.77h-10.27v.77l3.02.82,11.38,17.71ZM503.02,20.7c.98.67,2.08,1.22,3.31,1.63,1.23.42,2.5.82,3.82,1.2,1.41.42,2.66.82,3.74,1.2,1.09.38,2,.83,2.74,1.34.73.51,1.3,1.14,1.68,1.87.38.74.58,1.66.58,2.78,0,2.46-.81,4.32-2.42,5.57-1.62,1.25-3.77,1.87-6.46,1.87-.93,0-1.88-.1-2.86-.29-.98-.19-1.9-.53-2.78-1.03-.88-.5-1.66-1.19-2.35-2.09-.69-.9-1.19-2.05-1.51-3.46h-1.06l.29,6.53.53.53,1.58-1.3c2.47,1.47,5.36,2.21,8.69,2.21,2.05,0,3.8-.23,5.26-.7,1.46-.46,2.65-1.11,3.58-1.94.93-.83,1.62-1.82,2.06-2.95.45-1.13.67-2.36.67-3.67,0-1.66-.32-3.06-.96-4.18s-1.48-2.06-2.52-2.81c-1.04-.75-2.22-1.37-3.55-1.85-1.33-.48-2.68-.93-4.05-1.34-1.22-.35-2.32-.7-3.31-1.06-.99-.35-1.83-.77-2.52-1.25-.69-.48-1.22-1.06-1.58-1.73-.37-.67-.55-1.54-.55-2.59,0-2.14.72-3.84,2.16-5.09,1.44-1.25,3.38-1.87,5.81-1.87.8,0,1.64.1,2.52.29.88.19,1.72.54,2.52,1.03.8.5,1.52,1.19,2.16,2.09.64.9,1.1,2.05,1.39,3.46h1.1l-.29-6.48-.53-.53-1.54,1.25c-2.24-1.47-4.91-2.21-8.02-2.21-1.86,0-3.45.23-4.78.7-1.33.46-2.42,1.1-3.29,1.9-.86.8-1.49,1.75-1.9,2.86-.4,1.1-.6,2.28-.6,3.53,0,1.63.29,2.97.89,4.01.59,1.04,1.38,1.9,2.35,2.57Z";
const SUB_D = "M213.91,93.85c0,1.93-.43,3.39-1.28,4.37-.85.98-1.97,1.47-3.36,1.47-.88,0-1.6-.16-2.16-.48-.56-.32-1-.71-1.32-1.15h-.15l-.38,1.43h-1.32v-15.96h1.85v3.89c0,.48-.01.92-.03,1.33-.02.41-.05.74-.07.98h.11c.32-.47.76-.88,1.32-1.2.56-.32,1.28-.48,2.16-.48,1.4,0,2.52.49,3.37,1.46.85.97,1.27,2.43,1.27,4.36ZM212,93.83c0-2.84-1.02-4.26-3.05-4.26-1.2,0-2.03.34-2.49,1.03-.46.69-.68,1.75-.68,3.19v.08c0,1.39.23,2.45.68,3.18.46.73,1.3,1.1,2.53,1.1,1.01,0,1.76-.37,2.26-1.11.5-.74.75-1.81.75-3.21ZM224.01,94.61c-.2.58-.38,1.15-.57,1.71-.18.57-.32,1.03-.4,1.38h-.09c-.08-.46-.21-.95-.38-1.45-.17-.5-.36-1.04-.57-1.62l-2.43-6.4h-1.97l4.54,11.3-.59,1.49c-.24.6-.55,1.08-.95,1.45-.39.36-.91.54-1.55.54-.24,0-.46-.01-.68-.04-.22-.03-.4-.06-.56-.09v1.47c.18.04.4.08.65.11.25.04.55.05.88.05,1.09,0,1.95-.32,2.56-.95.62-.63,1.13-1.48,1.53-2.54l4.85-12.81h-2l-2.29,6.38ZM254.04,84.03l7.13,15.44h-2.11l-2.12-4.59h-7.06l-2.09,4.59h-2.1l7.05-15.44h1.29ZM256.07,92.98l-2.67-5.78-2.64,5.78h5.31ZM269.58,99.48h9.18v-1.91h-7.26v-4.55h6.23v-1.91h-6.23v-5.16h7.45v-1.91h-9.36v15.44ZM292.3,90.45c-1.02-.49-1.98-.94-2.54-1.59-.55-.63-.62-1.4-.2-2.11.34-.57,1.08-1.19,2.15-1.2.16,0,.35.01.58.04,1.18.16,1.73,1.41,1.73,1.42l.24.59,1.82-.78-.26-.58s-.5-1.11-1.44-1.81c-.21-.15-.47-.3-.76-.43-.53-.24-1.19-.37-1.88-.37h-.06c-1.84.03-3.14,1.12-3.75,2.14-.84,1.42-.69,3.09.4,4.35.82.95,2.01,1.52,3.16,2.07,1.33.63,2.59,1.23,3.08,2.3.27.58.26,1.23-.01,1.82-.33.72-1.01,1.25-1.84,1.46-.38.1-.75.15-1.1.15h-.05c-1.69,0-2.77-1.1-3.39-2.02l-.39-.58-1.68.9.46.71c1.23,1.87,3.01,2.9,5.01,2.9h.08c.49,0,1.01-.08,1.51-.21,1.39-.35,2.52-1.27,3.09-2.5.52-1.11.52-2.33.02-3.43-.78-1.71-2.41-2.48-3.99-3.23ZM304.06,85.95h4.71v13.54h1.91v-13.54h4.71v-1.91h-11.33v1.91ZM334.11,91.29h-7.85v-7.24h-1.91v15.43h1.91v-6.28h7.85v6.28h1.91v-15.43h-1.91v7.24ZM345.81,99.48h9.17v-1.91h-7.26v-4.55h6.23v-1.91h-6.23v-5.16h7.45v-1.91h-9.36v15.44ZM363.03,85.95h4.71v13.54h1.91v-13.54h4.71v-1.91h-11.33v1.91ZM383.31,99.48h1.91v-15.43h-1.91v15.43ZM395.01,99.48h1.91v-6.05h6.2v-1.91h-6.2v-5.54h8.07v-1.91h-9.98v15.41ZM418.07,90.97l-4.07-6.94h-2.19l5.31,9.15v6.3h1.91v-6.3l5.32-9.14h-2.18s-4.1,6.94-4.1,6.94Z";
const RULE_D = "M71.09,62.09l2.55,2.21c38.33.11,186.15.54,240.22.54s202.68-.96,240.56-1.22l1.77-1.54c-34.75-.31-187.2-1.64-242.3-1.64s-208.99,1.34-242.8,1.64Z";
const A_D = "M348.51,38.22v.77h-10.08v-.77l3.02-.86-4.08-9.79h-15.46l-4.22,9.79,4.08.86v.77h-8.45v-.77l3.07-.86,13.92-31.97h1.54l13.54,31.97,3.12.86ZM336.85,26.41l-7.11-16.99-7.29,16.99h14.4Z";

const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);
const span = (t, a, b) => clamp((t - a) / (b - a), 0, 1);
const ease = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
// Einfahren beschleunigt (kein Abbremsen am Ende), Falten uebernimmt mit voller
// Geschwindigkeit und bremst erst am Ziel ab -> eine durchgehende Bewegung.
const easeIn = (x) => x * x;
const easeOut = (x) => 1 - Math.pow(1 - x, 3);
// Sanft schneller Beginn je Teil: keine Ruckler durch die Staffelung, aber die
// Faltung uebernimmt die Geschwindigkeit des Einfahrens.
const foldK = (x) => 1 - Math.pow(1 - x, 1.5);
const smooth = (x) => x * x * (3 - 2 * x);
const mix = (a, b, k) => [a[0] + (b[0] - a[0]) * k, a[1] + (b[1] - a[1]) * k];
const r3 = (n) => Math.round(n * 1000) / 1000;

const A_BOX = { cx: 330.915, cy: 22.19 };

// --- die sechs Balken, jeweils im Uhrsinn bzw. Gegenuhrsinn ab "innen oben",
// damit das innere Ende zum Wurzelende des Flugzeugteils wird ----------------
// Nur die rechten Balken werden angeschrieben; die linken sind ihre exakte
// x-Spiegelung bei gleicher Eckenreihenfolge. Nur so laufen linke und rechte
// Haelfte durch dieselben Zwischenformen.
// MUSS mit der Achse der Nahtkorrektur uebereinstimmen: schon 0.005 Differenz
// legt die Auslöser der beiden Seiten auf verschiedene Seiten der Null - dann
// klemmt die linke Haelfte und die rechte nicht, und der linke Balken verzieht
// sich sichtbar.
const BAR_AXIS = 313.745 * 2;
const RIGHT_BARS = [
  { row: 0, part: 'tail', quad: [[538.11, 1.06], [626.39, 1.06], [615.62, 10.44], [538.11, 10.44]] },
  { row: 1, part: 'fuselage', quad: [[538.11, 16.8], [608.33, 16.8], [597.56, 26.18], [538.11, 26.18]] },
  { row: 2, part: 'wing', quad: [[538.11, 32.54], [590.27, 32.54], [579.5, 41.92], [538.11, 41.92]] },
];
const BARS = [];
for (const b of RIGHT_BARS) {
  BARS.push({ id: 'bar-l' + b.row, side: -1, row: b.row, part: b.part + '-l',
    quad: b.quad.map((p) => [r3(BAR_AXIS - p[0]), p[1]]) });
}
for (const b of RIGHT_BARS) {
  BARS.push({ id: 'bar-r' + b.row, side: 1, row: b.row, part: b.part + '-r', quad: b.quad });
}

// --- Zielteile: vorgegebene Kontur, je vier Anker --------------------------
const BASE = {
  // Die Vorlage besteht aus fuenf Teilen mit je vier Ankern: zwei Fluegeln,
  // zwei Leitwerksflaechen und einem Rumpf. Vier Anker sind genau die Anzahl,
  // die ein Balken hat - Ecke fuer Ecke, ohne Hilfspunkte.
  // Nase unten, Leitwerk oben; die Balkenreihen wandern damit ohne Kreuzung an
  // ihren Platz: obere Reihe -> Leitwerk, mittlere -> Rumpf, untere -> Fluegel.
  'fuselage-r': {
    // Rechte Rumpfhaelfte: Mittelachse, Flanke (leicht ausgebaucht), Nase.
    pts: [[313.745, 3.246], [315.858, 3.249], [316.385, 36.98], [313.745, 41.796]],
    curves: {
      1: [[315.858, 3.249], [316.385, 33.04]],
      2: [[316.385, 40.92], [313.745, 41.796]],
    },
    // Der Rumpf beginnt seine Umformung erst, wenn die Balken sich wirklich
    // treffen (eat endet bei 0.5, fold beginnt bei 0.44). Frueher zieht das
    // waagerechte Schrumpfen seine innere Kante zurueck und die mittlere Reihe
    // sieht aus, als komme sie spaeter an.
    win: [0.11, 0.86],
  },
  'wing-r': {
    pts: [[315.837, 17.984], [331.68, 16.448], [331.68, 18.752], [315.837, 24.897]],
    win: [0.07, 0.93],
  },
  'tail-r': {
    pts: [[313.745, 3.246], [321.138, 2.19], [321.138, 3.51], [313.745, 6.943]],
    win: [0.02, 1],
  },
};
let TARGETS;

// Die linken Teile sind exakt die x-Spiegelung der rechten - gleiche Ankerzahl,
// gleiche Reihenfolge, gleiche Kurvenindizes. Damit laufen linke und rechte
// Haelfte durch dieselben Zwischenformen; nur so bleibt die Faltung symmetrisch.
// Ankerliste eines Zielteils drehen: neuer Index j entspricht altem (j + k).
function rotPart(part, k) {
  const n = part.pts.length;
  const out = { pts: part.pts.map((_, j) => part.pts[(j + k) % n]), win: part.win.slice() };
  if (part.curves) {
    out.curves = {};
    for (let j = 0; j < n; j++) {
      const old = part.curves[(j + k) % n];
      if (old) out.curves[j] = old;
    }
  }
  return out;
}
const MIRROR_X = 313.745 * 2;
const mx = (p) => [MIRROR_X - p[0], p[1]];
function mirrorPart(src) {
  const out = { pts: src.pts.map(mx), win: src.win.slice() };
  if (src.curves) {
    out.curves = {};
    for (const i in src.curves) out.curves[i] = src.curves[i].map(mx);
  }
  return out;
}

// Die Vorlage liegt hier schon in Endlage vor - Nase unten, Leitwerk oben.
// Anders als in der ersten Fassung wird darum nicht mehr an der Waagerechten
// gespiegelt; die Ankerliste bleibt, wie sie in BASE steht.
function flipPart(pts, curves) {
  const out = { pts: pts.map((p) => p.slice()) };
  if (curves) {
    out.curves = {};
    for (const i in curves) out.curves[i] = curves[i].map((c) => c.slice());
  }
  return out;
}


const dist = (a, b) => Math.hypot(b[0] - a[0], b[1] - a[1]);
/** Umfangsanteile der Anker eines Vielecks. */
function params(pts) {
  const seg = pts.map((p, i) => dist(p, pts[(i + 1) % pts.length]));
  const total = seg.reduce((a, b) => a + b, 0);
  const out = [0];
  for (let i = 0; i < pts.length - 1; i++) out.push(out[i] + seg[i] / total);
  return out;
}
/** Punkt auf dem Umriss eines Vielecks beim Umfangsanteil f. */
function at(pts, f) {
  const seg = pts.map((p, i) => dist(p, pts[(i + 1) % pts.length]));
  const total = seg.reduce((a, b) => a + b, 0);
  let d = f * total;
  for (let i = 0; i < pts.length; i++) {
    if (d <= seg[i] || i === pts.length - 1) return mix(pts[i], pts[(i + 1) % pts.length], seg[i] ? d / seg[i] : 0);
    d -= seg[i];
  }
}
// Gemeinsame Ankerliste je Balken: die Vereinigung der Umfangsanteile beider
// Umrisse. Dadurch sind BEIDE Eckensaetze echte Anker - der Balken steht bei
// t = 0 exakt im Original, das Zielteil ist bei t = 1 exakt die Flugzeugkontur,
// und alle zusaetzlichen Anker liegen auf Kanten, bleiben also kollinear.
function buildBars() {
 for (const bar of BARS) {
  const tg = TARGETS[bar.part];
  const T = params(tg.pts);
  const curved = new Set(Object.keys(tg.curves || {}).map(Number));
  const list = T.map((f, i) => ({ f, tIdx: i }));
  for (const b of params(bar.quad)) {
    let seg = 0;
    for (let i = 0; i < T.length; i++) if (b >= T[i] - 1e-9) seg = i;
    if (curved.has(seg)) continue;                          // Nase nicht unterteilen
    if (T.some((f) => Math.abs(f - b) < 1e-6)) continue;
    list.push({ f: b, tIdx: null });
  }
  list.sort((a, b) => a.f - b.f);
  // Ecke auf Ecke, wenn beide Umrisse gleich viele Punkte haben: die Verteilung
  // nach Umfangsanteil taugt hier nicht, weil die Rumpfkontur von zwei langen
  // Senkrechten dominiert wird - alle vier Anker landen dann oben am Balken und
  // er wird als duenner Keil gezeichnet statt in voller Hoehe. (Ecken in
  // gekruemmten Segmenten werden ausserdem uebersprungen, wodurch dem Balken
  // seine aeusseren Ecken ganz fehlen.)
  const direct = tg.pts.length === bar.quad.length;
  if (direct) { list.length = 0; T.forEach((f, i) => list.push({ f, tIdx: i })); }
  bar.start = direct ? bar.quad.map((p) => [p[0], p[1]]) : list.map((e) => at(bar.quad, e.f));
  bar.target = list.map((e) => (e.tIdx !== null ? tg.pts[e.tIdx] : at(tg.pts, e.f)));
  bar.curves = {};
  list.forEach((e, j) => {
    const c = e.tIdx !== null && (tg.curves || {})[e.tIdx];
    if (c) bar.curves[j] = c;
  });
  buildPose(bar);
 }
}

// --- Starre Phase: Lage statt Punkte interpolieren ---------------------------
// Der Balken wird bis kurz vor Schluss nur gedreht, verschoben und in Laenge
// und Dicke skaliert. Weil das eine affine Abbildung des ganzen Balkens ist,
// bleibt er in jedem Zwischenschritt exakt seine eigene Form: gerade Kanten,
// parallele Seiten, keine Beulen. Erst im letzten Abschnitt wandern die Anker
// in die Zielkontur.
// Ab hier laeuft die Umformung in die Zielkontur, PARALLEL zur weiterlaufenden
// Bewegung: die Lage (drehen, schieben, skalieren) nutzt das ganze Fenster, die
// Kontur setzt nach 18 % ein. Beide laufen also gleichzeitig, und die Rundungen
// entstehen waehrend der Drehung statt danach.
export const RIGID_END = 0.18;
function buildPose(bar) {
  const xs = bar.quad.map((p) => p[0]), ys = bar.quad.map((p) => p[1]);
  const x0 = Math.min(...xs), x1 = Math.max(...xs);
  const y0 = Math.min(...ys), y1 = Math.max(...ys);
  bar.uv = bar.start.map((p) => [(p[0] - x0) / (x1 - x0), (p[1] - y0) / (y1 - y0)]);
  bar.from = { c: [(x0 + x1) / 2, (y0 + y1) / 2], a: 0, len: x1 - x0, th: y1 - y0 };

  // Hauptachse der Zielkontur (PCA) -> Lage, Laenge und Dicke des Zielkastens.
  const P = bar.target;
  const mx0 = P.reduce((s, p) => s + p[0], 0) / P.length;
  const my0 = P.reduce((s, p) => s + p[1], 0) / P.length;
  let sxx = 0, sxy = 0, syy = 0;
  for (const p of P) {
    const dx = p[0] - mx0, dy = p[1] - my0;
    sxx += dx * dx; sxy += dx * dy; syy += dy * dy;
  }
  let a = 0.5 * Math.atan2(2 * sxy, sxx - syy);
  const box = (ang) => {
    const ex = [Math.cos(ang), Math.sin(ang)], ey = [-ex[1], ex[0]];
    const us = P.map((p) => (p[0] - mx0) * ex[0] + (p[1] - my0) * ex[1]);
    const vs = P.map((p) => (p[0] - mx0) * ey[0] + (p[1] - my0) * ey[1]);
    const u0 = Math.min(...us), u1 = Math.max(...us);
    const v0 = Math.min(...vs), v1 = Math.max(...vs);

    const c = [mx0 + ex[0] * (u0 + u1) / 2 + ey[0] * (v0 + v1) / 2,
               my0 + ex[1] * (u0 + u1) / 2 + ey[1] * (v0 + v1) / 2];
    const o = [mx0 + ex[0] * u0 + ey[0] * v0, my0 + ex[1] * u0 + ey[1] * v0];
    const L = u1 - u0 || 1, T = v1 - v0 || 1;
    const uvOf = (p) => {
      const dx = p[0] - o[0], dy = p[1] - o[1];
      return [(dx * ex[0] + dy * ex[1]) / L, (dx * ey[0] + dy * ey[1]) / T];
    };
    return { c, a: ang, len: u1 - u0, th: v1 - v0, uvOf,
             uv: P.map((_, i) => [(us[i] - u0) / L, (vs[i] - v0) / T]) };
  };
  // Nur 0 oder 180 Grad sind erlaubt (Drehung, keine Spiegelung): die Variante
  // waehlen, in der jeder Anker auf seiner Seite des Balkens bleibt.
  const score = (t) => t.uv.reduce((s, q, i) =>
    s + (q[0] - 0.5) * (bar.uv[i][0] - 0.5) + (q[1] - 0.5) * (bar.uv[i][1] - 0.5), 0);
  const pack = (to) => {
    while (to.a - bar.from.a > Math.PI) to.a -= 2 * Math.PI;
    while (to.a - bar.from.a < -Math.PI) to.a += 2 * Math.PI;
    // Zielkontur UND Zielkurven im Kasten-Koordinatensystem des Ziels: dadurch
    // ist die Umformung von der Groesse und Drehung des Balkens entkoppelt und
    // kann parallel zur Bewegung laufen.
    const cUV = {};
    for (const i in bar.curves) cUV[i] = bar.curves[i].map(to.uvOf);
    return { to, toUV: to.uv, curvesUV: cUV };
  };
  let to = box(a);
  if (score(to) < 0) to = box(a + Math.PI);
  // 'flat': derselbe Aufbau, aber der Zielkasten liegt achsparallel - der Balken
  // wird dann nur verschoben und skaliert, gar nicht gedreht.
  bar.poses = { turn: pack(to), flat: pack(box(0)) };
}

// Wie viele Stellen die Zielankerliste des Rumpfs gedreht wird: legt fest,
// welche Balkenkante beim Falten nach oben zum Leitwerk wandert.
// 4 = die innere Balkenkante wandert nach oben zum Leitwerk, die aeussere
// nach unten zur Nase.
const FUSE_ROT = 4;
function configure() {
  TARGETS = {};
  for (const key of Object.keys(BASE)) {
    let part = { pts: BASE[key].pts.map((p) => p.slice()), win: BASE[key].win.slice() };
    if (BASE[key].curves) {
      part.curves = {};
      for (const i in BASE[key].curves) part.curves[i] = BASE[key].curves[i].map((p) => p.slice());
    }
    if (key === 'fuselage-r' && FUSE_ROT) part = rotPart(part, FUSE_ROT);
    TARGETS[key] = part;
    TARGETS[key.slice(0, -2) + '-l'] = mirrorPart(part);
  }
  for (const key in TARGETS) {
    const tg = TARGETS[key];
    const f = flipPart(tg.pts, tg.curves);
    tg.pts = f.pts;
    if (f.curves) tg.curves = f.curves;
  }
  buildBars();
}
configure();

function poly(pts, curves) {
  let d = 'M' + r3(pts[0][0]) + ',' + r3(pts[0][1]);
  for (let i = 0; i < pts.length; i++) {
    const p0 = pts[i], p1 = pts[(i + 1) % pts.length], c = curves && curves[i];
    const c1 = c ? c[0] : mix(p0, p1, 1 / 3), c2 = c ? c[1] : mix(p0, p1, 2 / 3);
    d += 'C' + r3(c1[0]) + ',' + r3(c1[1]) + ' ' + r3(c2[0]) + ',' + r3(c2[1]) +
         ' ' + r3(p1[0]) + ',' + r3(p1[1]);
  }
  return d + 'Z';
}

// Nase unten, Leitwerk oben
export const PLANE_D = [
  // Links in umgekehrter Reihenfolge: Spiegeln kehrt die Umlaufrichtung um,
  // gleiche Reihenfolge auf beiden Seiten ergaebe gegensinnige Flaechen.
  'M295.77,16.448L311.613,17.984L311.613,24.897L295.77,18.752Z',
  'M331.68,18.752L315.837,24.897L315.837,17.984L331.68,16.448Z',
  'M306.352,2.19L313.745,3.246L313.745,6.943L306.352,3.51Z',
  'M321.138,3.51L313.745,6.943L313.745,3.246L321.138,2.19Z',
  'M315.858,3.249C315.858,3.249 316.385,33.04 316.385,36.98C316.385,40.92 313.745,41.796 313.745,41.796C313.745,41.796 311.105,40.92 311.105,36.98C311.105,33.04 311.633,3.249 311.633,3.249L313.745,3.246Z',
].join('');
export const PLANE_BOX = { x: 295.77, y: 2.19, width: 35.91, height: 40, cx: 313.745, cy: 22.19 };

/**
 * Ein Balken bei Faltungsfortschritt m (0 = Balken, 1 = Flugzeugteil).
 * @param off zusaetzlicher Versatz des Balkens in x (Einfahrbewegung)
 */
export function barPath(bar, m, off = 0, mode = 'turn') {
  const P = bar.poses[mode] || bar.poses.turn;
  const k = span(m, TARGETS[bar.part].win[0], TARGETS[bar.part].win[1]);
  const kr = span(k, 0, 0.92);                      // Lage: drehen, schieben, skalieren
  const stagger = bar.part.startsWith('fuselage');
  // Rumpf: erst waagerecht schrumpfen, dann senkrecht wachsen.
  const pLen = stagger ? smooth(span(kr, 0, 0.46)) : kr;
  // Die Hoehe waechst schon, waehrend der Balken noch schmaler wird: sonst
  // steht die Rumpfreihe als flacher Streifen zwischen den Nachbarreihen, die
  // ihre Form bereits aendern - es klaffen Luecken nach oben und unten.
  const pTh  = stagger ? smooth(span(kr, 0.08, 0.9)) : kr;
  // Die Verjuengung laeuft MIT dem Wachsen, nicht danach. Nacheinander zieht
  // die Ankerphase die Spitze nach innen, nachdem der Kasten seine volle Hoehe
  // schon hat - die Nase fahrt dann sichtbar zurueck und wieder heraus. Zusammen
  // addieren sich Wachsen und Verjuengen zu einer einsinnigen Bewegung.
  const km = stagger ? pTh : span(k, RIGID_END, 1);
  // Rundungen deutlich spaeter als die Anker: solange die Teile noch wandern,
  // bleiben ihre Kanten gerade und die Zwischenformen klar lesbar. Erst kurz
  // vor Schluss biegt sich die Nase aus.
  // Rundungen erst zum Schluss - sie sind es, die die Zwischenformen weich
  // aussehen lassen, nicht die Verjuengung.
  // Beim Rumpf beginnt die Rundung schon, sobald er unter den Fluegeln
  // erscheint (k = 0.42 entspricht t = 0.68), nicht erst kurz vor Schluss.
  const kc = smooth(span(k, stagger ? 0.42 : 0.86, 1));
  const A = bar.from, B = P.to;
  const ang = A.a + (B.a - A.a) * kr;
  const ex = [Math.cos(ang), Math.sin(ang)], ey = [-ex[1], ex[0]];
  // Laenge und Dicke als Mischung aus linear und geometrisch: linear allein
  // laesst den Balken bis zuletzt lang und dann in einem Ruck verschwinden,
  // geometrisch allein ist die Faltung schon bei zwei Dritteln fertig.
  const scal = (a, b, p) => 0.85 * (a + (b - a) * p) + 0.15 * (a * Math.pow(b / a, p));
  const len = scal(A.len, B.len, pLen);
  // Ober- und Unterkante des Rumpfs laufen getrennt: die Oberkante muss die
  // Leitwerkreihe treffen, sobald die Balken zusammengestossen sind, sonst
  // bleibt zwischen Leitwerk und Rumpf ein offenes Band stehen (gemessen 6.9
  // Einheiten bis t = 0.73). Die Unterkante darf sich Zeit lassen - nach unten
  // ist frueh Kontakt zur Fluegelreihe. Ein gemeinsames th kann beides nicht.
  let th = scal(A.th, B.th, pTh);
  let cyOff = 0;
  if (stagger) {
    const aTop = A.c[1] - A.th / 2, aBot = A.c[1] + A.th / 2;
    const bTop = B.c[1] - B.th / 2, bBot = B.c[1] + B.th / 2;
    const top = aTop + (bTop - aTop) * span(kr, 0.1, 0.44);
    const bot = aBot + (bBot - aBot) * pTh;
    th = bot - top;
    cyOff = (top + bot) / 2 - (A.c[1] + (B.c[1] - A.c[1]) * pTh);
  }
  // Die Mitte folgt beim Rumpf den jeweiligen Achsen: waagerecht dem
  // Schrumpfen, senkrecht dem Wachsen - sonst wandert der Balken schon nach
  // oben, waehrend er noch schmaler wird.
  // Nach dem Kontakt wird der Rumpfbalken an der ACHSE verankert, nicht an
  // seiner eigenen Mitte: die inneren Punkte bleiben stehen, nur die aeusseren
  // fahren weiter nach innen, bis die Rumpfbreite erreicht ist. Um die eigene
  // Mitte geschrumpft wandert die innere Kante mit nach aussen, die
  // Nahtkorrektur zieht sie zurueck - und dieser Widerspruch war der Sprung.
  // Die Formel laeuft von selbst genau auf die Ziellage zu, weil die innere
  // Kante des Rumpfziels exakt auf der Achse liegt.
  const cxFree = (A.c[0] + off) + (B.c[0] - A.c[0] - off) * (stagger ? pLen : kr);
  const pinned = stagger && (MIRROR_X / 2 - ((bar.side < 0 ? EAT_L : EAT_R) + off)) * bar.side * -1 <= 0.05;
  const cx = pinned ? MIRROR_X / 2 + bar.side * (len / 2) : cxFree;
  const cy = A.c[1] + (B.c[1] - A.c[1]) * pTh + cyOff;
  const place = (u, v) => {
    const du = (u - 0.5) * len, dv = (v - 0.5) * th;
    return [cx + ex[0] * du + ey[0] * dv, cy + ex[1] * du + ey[1] * dv];
  };
  // Kontur im eigenen Koordinatensystem umformen, dann durch die MOMENTANE
  // Lage abbilden: Rundungen entstehen waehrend der Drehung, ohne dass die
  // Groesse vorzeitig auf die Endform springt.
  const uv = km > 0 ? bar.uv.map((q, i) => mix(q, P.toUV[i], km)) : bar.uv;
  const pts = uv.map((q) => place(q[0], q[1]));
  const curves = {};
  for (const i in P.curvesUV) {
    const q0 = uv[i], q1 = uv[(+i + 1) % uv.length];
    curves[i] = P.curvesUV[i].map((c, j) =>
      place(...mix(mix(q0, q1, j === 0 ? 1 / 3 : 2 / 3), c, kc)));
  }
  // Leitwerk (row 0) und Fluegel (row 1) treffen sich im Flugzeug nicht selbst,
  // sondern am Rumpf - und der schliesst die Mitte erst am Ende. Ohne Korrektur
  // klafft dort waehrend der Faltung eine Luecke. Die innere Kante wird darum
  // an der Mittellinie gehalten; die Verschiebung klingt mit der Lage aus,
  // damit die Endform exakt bleibt.
  // Ausgeloest wird sie von der Annaeherung, nicht von der Faltung: sobald die
  // natuerliche innere Kante (nur eingefahren, ungefaltet) noch APPROACH
  // Einheiten von der Mittellinie entfernt ist, blendet die Korrektur ueber
  // diese Strecke ein. Damit ist sie im Moment der Beruehrung voll da (kein
  // Spalt) und wird ueber mehrere Frames statt in einem Sprung aufgebaut.
  // Die Bedingung haengt allein an der Geometrie (Reihe und Annaeherung), nicht
  // am Zeichenmodus: sonst fehlt sie in jeder Variante ohne rotate-Feld.
  // Kein hartes Abschalten (das kappte die Ausblendung mitten in ihrer Rampe
  // und war der letzte Ruckler): hold laeuft bis k = 1 sauber auf 0 aus.
  // Gilt fuer ALLE Teile, auch fuer den Rumpf: ohne Drehung schrumpft dessen
  // Lagekasten symmetrisch um seine eigene Mitte, die innere Kante wandert also
  // von der Achse weg und laesst einen Schlitz offen. Fuer diese Reihe ist die
  // Korrektur am Ende gratis - die Zielkante liegt genau auf der Achse.
  {
    const inner = bar.side < 0
      ? Math.max(...pts.map((p) => p[0]))
      : Math.min(...pts.map((p) => p[0]));
    // 0.4 Einheiten Ueberlappung: exakt aneinandergelegte Kanten hinterlassen
    // beim Rastern eine Haarlinie, die wie ein Spalt aussieht.
    const over = 0.4 * bar.side * -1;
    // Die inneren Anker bleiben dauerhaft auf der Mittelachse - auch am Ende.
    // Sie liegen dort hinter dem Rumpf, der in der Endform breiter ist als die
    // Naht, die Silhouette bleibt also unveraendert. Jedes Freigeben wuerde die
    // Anker nach aussen auf die Rumpfflanke setzen und genau dort die Kerbe
    // aufreissen, weil der Rumpf auf dieser Hoehe noch nicht so weit ist.
    // Erst ganz am Schluss loslassen, wenn der Rumpf die Naht schon deckt.
    // Frueher (0.8) riss die Kerbe auf, dauerhaft (1) blieben die Anker auf der
    // Mittelachse und die Endform stimmte nicht mehr mit dem Flugzeug ueberein.
    // Der Rumpf braucht kein Auslaufen (seine Zielkante liegt auf der Achse),
    // alle anderen Reihen schon - sonst stimmt die Endform nicht.
    const hold = bar.part.startsWith('fuselage') ? 1 : 1 - smooth(span(k, 0.94, 1));
    // Kein Zeitfenster, sondern eine Schranke: die innere Kante wird nur nach
    // innen geschoben, wenn sie die Mittellinie noch nicht erreicht hat, und
    // nie darueber hinaus gezogen. Damit greift die Korrektur genau im Moment
    // der Beruehrung (also ohne Spalt) und bringt keine eigene Bewegung mit.
    // off ist bereits vorzeichenbehaftet (links positiv, rechts negativ), darf
    // also auf beiden Seiten nur addiert werden.
    const natural = (bar.side < 0 ? EAT_L : EAT_R) + off;
    // Vorzeichenbehaftet: nach der Beruehrung ist der Wert negativ, span()
    // klemmt auf 0 und die Korrektur bleibt voll aktiv. Mit einem Betrag waere
    // sie beim Weiterfahren wieder ausgeklungen und der Spalt ginge auf.
    // Um die Ueberlappung vorgezogen: bei reinem Kontakt (approach = 0) ist die
    // Einblendung noch nicht ganz bei 1, es bleibt eine Haarlinie stehen -
    // sichtbar genau bei 50 %, wo die Balken aufeinandertreffen. Die Rumpfreihe
    // klemmt absolut und hatte das Problem nicht.
    const approach = (MIRROR_X / 2 - natural) * bar.side * -1 - 0.8;
    const g = smooth(1 - span(approach, 0, APPROACH));
    const d = (MIRROR_X / 2 + over - inner) * hold * g;
    const dx = bar.side < 0 ? Math.max(0, d) : Math.min(0, d);
    // Die Rumpfreihe wird pro Anker geklemmt und darf nicht an der Balkenbreite
    // haengen: sobald die breite Mitte die Achse erreicht hat, ist dx = 0 - die
    // spitz zulaufende Nase braucht die Korrektur aber genau dann noch.
    const perAnchor = bar.part.startsWith('fuselage');
    // Eine Schranke darf erst greifen, wenn der Balken die Achse tatsaechlich
    // erreicht hat (approach <= 0). Mit dem weichen Fenster g feuerte sie schon
    // beim Anfahren und riss die inneren Anker in einem Schritt auf die Achse -
    // das war der Sprung.
    // Fuer die Rumpfreihe ZAEHLT NUR die Schranke: das weiche dx als Einlass zu
    // nehmen war der Sprung - schon ein Bruchteil davon oeffnete den Block, und
    // der absolute Clamp riss die Anker dann in einem Schritt auf die Achse.
    // Toleranz: die Balkenmitte (313.75) und die Flugzeugachse (313.745) liegen
    // 0.005 auseinander. Ohne Spielraum bleibt der rechte Auslöser dauerhaft
    // geschlossen, waehrend der linke oeffnet - die linke Haelfte verzieht sich
    // dann und die rechte nicht.
    if (perAnchor ? approach <= 0.05 : dx) {
      // Nur die inneren Anker verschieben, nicht den ganzen Balken. Sonst
      // wandert beim Auslaufen der Korrektur auch die aeussere Spitze wieder
      // nach aussen - eine Richtungsumkehr, die am Ende als Zucken sichtbar
      // ist. So bleibt die Aussenkante durchgehend ruhig, und das Auslaufen
      // spielt sich hinter dem Rumpf ab, der die Naht dann deckt.
      // Pro Anker entscheiden, nicht pro Balkenecke: die Ankerliste ist die
      // Vereinigung beider Umrisse und damit laenger als bar.quad. Mit dem
      // kurzen Index wurden die falschen Punkte verschoben und das Teil verzog
      // sich.
      const qm = bar.quad.reduce((s, p) => s + p[0], 0) / bar.quad.length;
      // Beim Rumpf entscheidet die ZIELlage: geklemmt werden nur die Anker, die
      // am Ende ohnehin auf der Achse liegen. Die Markierung aus der
      // Startgeometrie ist dafuer zu weit gefasst - sie erfasst auch Anker der
      // Aussenflanke, und die Haelfte wurde dadurch zur Nadel auf der Achse.
      const isInner = bar.part.startsWith('fuselage')
        ? bar.target.map((p) => Math.abs(p[0] - MIRROR_X / 2) < 0.6)
        : bar.start.map((p) => (bar.side < 0 ? p[0] > qm : p[0] < qm));
      // Der Rumpf laeuft nach unten spitz zu: seine inneren Anker liegen auf
      // sehr verschiedenen x. Eine gemeinsame Verschiebung kann darum entweder
      // die breite Mitte oder die Nase auf der Achse halten, nie beides - die
      // Nase spaltete sich dadurch in zwei Zinken. Fuer diese Reihe wird jeder
      // Anker einzeln auf die Achse geklemmt. Am Ende ist das gratis, weil die
      // Zielkante des Rumpfs ohnehin genau auf der Achse liegt.
      // Mit derselben Ueberlappung wie die anderen Reihen: exakt aneinander
      // gelegte Kanten hinterlassen beim Rastern eine Haarlinie, die als Spalt
      // zu sehen ist. Die Silhouette bleibt gleich, weil die Gegenhaelfte
      // ohnehin bis hierher reicht.
      const axis = MIRROR_X / 2 + over;
      const fix = (p) => {
        if (!perAnchor) { p[0] += dx; return; }
        p[0] = bar.side < 0 ? Math.max(p[0], axis) : Math.min(p[0], axis);
      };
      pts.forEach((p, i) => { if (isInner[i]) fix(p); });
      for (const i in curves) {
        const a = isInner[+i], b = isInner[(+i + 1) % pts.length];
        if (a) fix(curves[i][0]);
        if (b) fix(curves[i][1]);
      }
    }
  }
  return poly(pts, curves);
}

/** Alle sechs Balken zusammen; bei m = 1 exakt PLANE_D. */
export function shapePath(m, off = 0, rotate) {
  if (m >= 0.9995) return PLANE_D;
  return BARS.map((b) => barPath(b, m, b.side * off, barMode(b, rotate))).join('');
}
/** rotate: {tail?:boolean, wing?:boolean, fuselage?:boolean} - default alle true */
function barMode(bar, rotate) {
  if (!rotate) return 'turn';
  const row = bar.part.split('-')[0];
  return rotate[row] === false ? 'flat' : 'turn';
}

/** angle = 0 heisst: Nase nach unten (Ausgangslage dieser Variante). */
export function planeTransform({ x = 0, y = 0, size = PLANE_BOX.width, angle = 0 } = {}) {
  const k = size / PLANE_BOX.width;
  return 'translate(' + x + ' ' + y + ') rotate(' + angle + ') scale(' + k + ') translate(' +
    -PLANE_BOX.cx + ' ' + -PLANE_BOX.cy + ')';
}

export const DEFAULT_PHASES = {
  sub:    [0.00, 0.16],   // Unterzeile rutscht nach oben unter die Linie
  rule:   'eat',          // Linie schrumpft im Gleichschritt mit den Balken
  // eat und fold liegen auf der gemeinsamen Zeitkurve ease(t), nicht auf t
  eat:    [0.00, 0.55],   // Balken fahren nach innen, die Wortmarke verschwindet darunter
  fold:   [0.42, 1.00],   // ueberlappt das Einfahren: die Balken falten sich zum Flugzeug
};

const EAT_L = 89.39, EAT_R = 538.11;
const EAT_TRAVEL = 188;
// Volle Strecke: die inneren Balkenkanten treffen sich in der Logomitte.
// Einblendstrecke der Nahtkorrektur, in Zielkoordinaten. Kurz halten: ueber eine
// lange Strecke zieht sie Leitwerk und Fluegel schon vor dem Kontakt zur Achse,
// die mittlere Reihe wartet dagegen auf echten Kontakt - dann kommen die drei
// Reihen sichtbar zu verschiedenen Zeiten an.
// Einblendstrecke der Nahtkorrektur. Praktisch null: jeder Vorlauf zieht die
// betroffene Reihe frueher zusammen als die anderen, und dann stossen Leitwerk
// und Fluegel sichtbar vor dem Rumpf zusammen. Bei 0 greift die Schranke genau
// im Moment der Beruehrung, wo ihr Betrag ohnehin fast null ist.
const APPROACH = 0.05;
export const COLLIDE_TRAVEL = r3((EAT_R - EAT_L) / 2);

/**
 * Variante: wie COLLIDE_PHASES, aber Leitwerk- und Fluegelbalken werden gar
 * nicht gedreht - sie wandern nur nach innen und schrumpfen, die Kontur macht
 * den Rest. Nur die Rumpfbalken klappen.
 */
export const FLAT_PHASES = {
  sub:    [0.00, 0.16],
  rule:   'eat',
  eat:    [0.00, 0.50],
  fold:   [0.44, 1.00],
  travel: 0,               // wird unten gesetzt
  rotate: { tail: false, wing: false, fuselage: true },
};

/** Variante: die Balken stossen erst zusammen, dann faltet sich das Flugzeug. */
export const COLLIDE_PHASES = {
  sub:    [0.00, 0.16],
  rule:   'eat',
  eat:    [0.00, 0.55],   // fahren bis zum Stoss in der Mitte
  fold:   [0.55, 1.00],   // von dort aus in die Flugzeugform (linear in t)
  travel: COLLIDE_TRAVEL,
};
FLAT_PHASES.travel = COLLIDE_TRAVEL;

/**
 * Variante ohne jede Drehung: auch der Rumpf entsteht nur durch Verschieben und
 * Streckenn seiner Anker - die Balken stossen in der Mitte zusammen, danach
 * wandern die oberen Anker nach oben und die unteren nach unten, bis aus dem
 * liegenden Balken die stehende Rumpfhaelfte geworden ist.
 */
export const NOSPIN_PHASES = {
  sub:    [0.00, 0.16],
  rule:   'eat',
  eat:    [0.00, 0.50],
  fold:   [0.44, 1.00],
  travel: COLLIDE_TRAVEL,
  rotate: { tail: false, wing: false, fuselage: false },
};
const RULE_CX = 313.6;
export const SUB_CLIP = { y: 65.2, height: 45 };

/**
 * Alle Zeichenwerte fuer einen Fortschritt t (0..1).
 * @returns {{t:number, viewBox:string, clip:{x:number,width:number},
 *  text:{d:string,opacity:number}, sub:{d:string,transform:string,opacity:number,clip:object},
 *  rule:{d:string,transform:string}, letter:{d:string,opacity:number},
 *  bars:Array<{id:string,d:string}>, shape:{d:string,strokeWidth:number}}}
 */
export function frame(t, phases = DEFAULT_PHASES) {
  t = clamp(t, 0, 1);
  const subP = span(t, phases.sub[0], phases.sub[1]);
  // 'eat': die Linie haengt am Weg der Balken - sie ist genau dann verschwunden,
  // wenn die Balken in der Mitte zusammenstossen. Ein Zahlenpaar geht auch.
  const ruleP = phases.rule === 'eat' ? null : phases.rule;
  // Einfahren und Falten haengen an EINER gemeinsamen Zeitkurve; ihre Fenster
  // ueberlappen, damit die Bewegung ohne Geschwindigkeitssprung durchlaeuft.
  const master = smooth(t);
  // Abbremsender Ausklang: das Einfahren endet nicht mit voller Geschwindigkeit,
  // sonst faellt die sichtbare Bewegung im Moment des Zusammentreffens auf ein
  // Drittel ab und liest sich als Halt.
  // Linear: jede Bremskurve am Ende des Einfahrens liest sich als Halt, weil
  // die Faltung des Leitwerks erst kurz danach sichtbar wird.
  // Das Einfahren traegt viel mehr Weg pro Zeitschritt als die Faltung. Damit
  // an der Uebergabe die Geschwindigkeit nicht abfaellt, wird der Weg vorne
  // schnell und hinten flach abgefahren - der flache Teil ueberlappt die
  // Faltung, deren Eigenbewegung dort uebernimmt.
  const e = span(master, phases.eat[0], phases.eat[1]);
  const eat = 1 - Math.pow(1 - e, 1.7);
  // Die Faltung laeuft linear in t, nicht auf der gebogenen Zeitkurve: sonst
  // ist die Formaenderung bei zwei Dritteln schon abgeschlossen und das letzte
  // Viertel (beim Scrollen: die letzte Wegstrecke) bewegt nichts mehr.
  const m = span(t, phases.fold[0], phases.fold[1]);
  const travel = phases.travel ?? EAT_TRAVEL;
  const off = travel * eat;
  // knapp vor dem Stoss ganz weg, damit kein letzter Punkt allein stehen bleibt
  // Am WEG der Balken, nicht an der Zeit: die Linie schrumpft synchron mit
  // ihnen und ist genau beim Zusammentreffen auf Null. Damit kein letzter Punkt
  // allein stehen bleibt, wird das letzte Stueck ausgeblendet statt abgeschnitten.
  const rule = ruleP ? ease(span(t, ruleP[0], ruleP[1])) : eat;
  return {
    t,
    viewBox: VIEW_BOX,
    clip: {
      x: EAT_L + off,
      width: Math.max(0, (EAT_R - off) - (EAT_L + off)),
    },
    text: { d: TEXT_D, opacity: 1 - span(eat, 0.42, 0.76) },
    sub: {
      d: SUB_D, clip: SUB_CLIP,
      transform: 'translate(0 ' + r3(-44 * ease(subP)) + ')',
      opacity: 1 - span(subP, 0.55, 1),
    },
    rule: {
      d: RULE_D, opacity: 1 - span(rule, 0.93, 1),
      transform: 'translate(' + RULE_CX + ' 0) scale(' + r3(1 - rule) + ' 1) translate(' + -RULE_CX + ' 0)',
    },
    // Das A ist Teil der Wortmarke: derselbe Clip, dieselbe Deckkraft.
    letter: { d: A_D, opacity: 1 - span(eat, 0.42, 0.76) },
    bars: BARS.map((b) => ({ id: b.id, d: barPath(b, m, b.side * -off, barMode(b, phases.rotate)) })),
    // Haarfeiner Rand, der die Teile waehrend der Faltung verschweisst; an
    // beiden Enden exakt 0, Balken und Flugzeug bleiben unveraendert.
    shape: { d: '', strokeWidth: r3(0.85 * Math.sin(Math.PI * m)) },
  };
}

const NS = 'http://www.w3.org/2000/svg';
let uid = 0;
export function createMorph(target, opts = {}) {
  const { color = ACCENT, phases = DEFAULT_PHASES } = opts;
  let svg = target, owned = false;
  if (!svg || svg.tagName.toLowerCase() !== 'svg') {
    svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
    svg.style.display = 'block';
    target.appendChild(svg);
    owned = true;   // selbst angelegt -> destroy() raeumt es wieder ab
  }
  svg.setAttribute('viewBox', VIEW_BOX);
  const n = ++uid, idEat = 'bf-eat-' + n, idSub = 'bf-sub-' + n;
  const mk = (tag, parent, attrs) => {
    const el = document.createElementNS(NS, tag);
    for (const k in attrs) el.setAttribute(k, attrs[k]);
    parent.appendChild(el);
    return el;
  };
  const root = mk('g', svg, { fill: color });
  const defs = mk('defs', root, {});
  const cpEat = mk('clipPath', defs, { id: idEat });
  const rect = mk('rect', cpEat, { y: '-20', height: '150' });
  const cpSub = mk('clipPath', defs, { id: idSub });
  mk('rect', cpSub, { x: '0', y: SUB_CLIP.y, width: '700', height: SUB_CLIP.height });
  const textEl = mk('path', root, { d: TEXT_D, 'fill-rule': 'evenodd', 'clip-path': 'url(#' + idEat + ')' });
  const subWrap = mk('g', root, { 'clip-path': 'url(#' + idSub + ')' });
  const subEl = mk('path', subWrap, { d: SUB_D, 'fill-rule': 'evenodd' });
  const ruleEl = mk('path', root, { d: RULE_D });
  const letterEl = mk('path', root, { d: A_D, 'fill-rule': 'evenodd', 'clip-path': 'url(#' + idEat + ')' });
  const barEls = BARS.map(() => mk('path', root, { stroke: color, 'stroke-linejoin': 'round', 'stroke-width': '0' }));
  let _t = -1;
  function render(t) {
    if (t === _t) return;
    _t = t;
    const f = frame(t, phases);
    rect.setAttribute('x', r3(f.clip.x));
    rect.setAttribute('width', r3(f.clip.width));
    textEl.setAttribute('opacity', r3(f.text.opacity));
    subEl.setAttribute('transform', f.sub.transform);
    subEl.setAttribute('opacity', r3(f.sub.opacity));
    ruleEl.setAttribute('transform', f.rule.transform);
    ruleEl.setAttribute('opacity', r3(f.rule.opacity));
    letterEl.setAttribute('opacity', r3(f.letter.opacity));
    f.bars.forEach((b, i) => {
      barEls[i].setAttribute('d', b.d);
      barEls[i].setAttribute('stroke-width', f.shape.strokeWidth);
    });
  }
  render(0);
  return {
    element: svg,
    get progress() { return _t; },
    set progress(v) { render(clamp(+v || 0, 0, 1)); },
    setProgress(v) { render(clamp(+v || 0, 0, 1)); },
    setColor(c) { root.setAttribute('fill', c); barEls.forEach((e) => e.setAttribute('stroke', c)); },
    destroy() { root.remove(); if (owned) svg.remove(); },
  };
}
